import { Box, type BoxProps } from '@mui/material';

interface PageContainerProps extends BoxProps {
  /** Override padding (default: 3, which is 24px) */
  padding?: number | string;
  /** Disable default padding completely */
  noPadding?: boolean;
  /** Full height container (useful for pages with their own scrolling) */
  fullHeight?: boolean;
}

/**
 * Standardized page container that ensures consistent layout across all pages.
 *
 * Usage:
 * - Wrap all page content in this component
 * - Use `noPadding` for pages that need edge-to-edge content (e.g., DataGrid pages)
 * - Use `fullHeight` for pages with internal scrolling (e.g., recipe editor)
 */
export const PageContainer = ({
  children,
  padding = 3,
  noPadding = false,
  fullHeight = false,
  sx,
  ...rest
}: PageContainerProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: fullHeight ? '100%' : 'auto',
        p: noPadding ? 0 : padding,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
